export const config = {
  'development': {
    apiHost: "localhost",
    apiStorage: "https://t3-storage-stag.grupofacthum.com/api/v1",    
    
    // apiStorage: "http://192.168.0.166:3000/api/v1",    
    client: {
      url: 'http://localhost:3000/api'
    },
    originHost: 'http://localhost:3000',
  },
  'staging': {
    apiStorage: "https://metrics-storage.gsgmetrics.com/api/v1",    
    apiHost: "staging.host",
    client: {
      url: 'https://metrics.gsgmetrics.com/api'
    },
    originHost: 'https://metrics.gsgmetrics.com',
  },
  'production': {
    apiHost: "production.host",
    apiStorage: "https://t4-storage.string-projects.com/api/v1",
    client: {
      url: 'https://t4.string-projects.com/api'
    },
    originHost: 'https://t4.string-projects.com',
  }
}

export default config;
